import { AxiosRequestConfig, AxiosResponse } from "axios";
import { HttpClient, IHttpRequestable } from "../utilities";

export class HttpRepository {
  public constructor(protected readonly _client: IHttpRequestable = new HttpClient()) {
  }
  
  protected async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._client.get(
      url,
      config,
    );
  }

  protected async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._client.post(
      url,
      data,
      config,
    );
  }
}